import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {NachrichtenOrdner} from '../../model/nachrichten-ordner';
import {ApiUrlService} from "./api-url.service";

@Injectable({
  providedIn: 'root' // ✅ Ensures the service is available globally
})
export class OrdnerService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrlService = inject(ApiUrlService);

  public getOrdner(): Observable<NachrichtenOrdner[]> {
    const apiUrl = `${this.apiUrlService.getApiUrl()}/ordner`;
    return this.http.get<NachrichtenOrdner[]>(apiUrl);
  }
}
